import { z } from "zod";
export const linerUsedUpdateDtoSchema = z.object({
    linerUsedFromUser: z.string().min(1),
    linerUsedInData: z.string().nullable(),
});
//# sourceMappingURL=liner-used-update.schema.js.map